import React from "react";

import CommonModal from "../../Components/Modal";
import { EmailTemplatePreviewItem } from "../../Store/Reducers/EmailActivitySlice";

interface EmailTemplatePreviewModalProps {
  isOpen: boolean;
  toggle: () => void;
  template: EmailTemplatePreviewItem | null;
  emailTypeLabel?: string;
  badgeLabel?: string;
}

const EmailTemplatePreviewModal: React.FC<EmailTemplatePreviewModalProps> = ({
  isOpen,
  toggle,
  template,
  emailTypeLabel,
  badgeLabel = "Sample template data",
}) => {
  const title = template?.name || emailTypeLabel || "Email Template";
  const subtitle = template?.subject
    ? `Subject: ${template.subject}`
    : undefined;

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      subtitle={subtitle}
      size="4xl"
      usePortal
      contentClassName="overflow-hidden flex flex-col"
      headerActions={
        badgeLabel ? (
          <div className="flex items-center px-3 py-1 bg-yellow-100 rounded-full">
            <span className="text-xs font-medium text-yellow-700 whitespace-nowrap">
              {badgeLabel}
            </span>
          </div>
        ) : undefined
      }
    >
      {template?.html ? (
        <iframe
          title={title}
          srcDoc={template.html}
          className="w-full h-[70vh] rounded-md border border-gray-200 bg-white"
          sandbox=""
        />
      ) : (
        <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-6 text-center">
          <p className="text-sm text-amber-800">
            Preview is not available for this email type
            {emailTypeLabel ? ` (${emailTypeLabel})` : ""}.
          </p>
        </div>
      )}
    </CommonModal>
  );
};

export default EmailTemplatePreviewModal;
